import { render, staticRenderFns } from "./invoice-table.vue?vue&type=template&id=84fa5b3e&scoped=true"
import script from "./invoice-table.vue?vue&type=script&lang=js"
export * from "./invoice-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84fa5b3e",
  null
  
)

export default component.exports